import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessUnprocessedNcCounts } from '../services/getBusinessUnprocessedNcCounts.service';

// Argument: businessId (string) — the EMPLOYER project's own business_id.
// Result stored under that same id in
// nonConformanceReportsSlice.businessSummaryByBusinessId.
export const loadBusinessUnprocessedNcCounts = createAsyncThunk(
  'nonConformanceReports/loadBusinessUnprocessedNcCounts',
  async (businessId) => {
    const response = await getBusinessUnprocessedNcCounts(businessId);
    return response;
  }
);
